import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ContentControlStudioVODViewModel } from "../../content-control-studio-vod-view-model";

@Component({
  selector: "evrideo-content-control-studio-vod-header",
  templateUrl: "./content-control-studio-vod-header.component.html",
  styleUrl: "./content-control-studio-vod-header.component.scss",
})
export class ContentControlStudioVODHeaderComponent implements OnInit, OnDestroy {
  readonly placeholder = "--:--:--.---";

  @Input() title: string;
  @Input() vm!: ContentControlStudioVODViewModel;

  get videoDuration(): number {
    try {
      return this.vm?.timelineRef?.currentVideoTimeInMs() ?? 0;
    } catch {
      return 0;
    }
  }

  get currentTime(): number {
    try {
      return this.vm?.timelineRef?.currentVideoPlayTimeForUI() ?? 0;
    } catch {
      return 0;
    }
  }

  private _rafId: number | null = null;

  constructor(private _cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    const tick = (): void => {
      this._cd.markForCheck();
      this._rafId = requestAnimationFrame(tick);
    };
    this._rafId = requestAnimationFrame(tick);
  }

  ngOnDestroy(): void {
    if (this._rafId != null) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
  }
}
